import { FC, ReactNode } from 'react'
import classnames from 'classnames'

type MessageProps = {
  type?: string
  children?: ReactNode
}

const Message: FC<MessageProps> = ({ type = 'info', children }) => {
  const className = classnames('message', `message--${type}`)
  return <span className={className}>{children}</span>
}

export default Message
